var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4", class: _vm.errorShow ? "error" : "" },
    [
      _c(
        "div",
        { staticClass: "flex gap-[10px]" },
        [
          _c(
            "label",
            {
              staticClass: "checkbox-wrapp relative block",
              class: _vm.textInLabel ? "flex items-center gap-[10px]" : "block",
            },
            [
              _c(
                "span",
                { staticClass: "block relative w-5 h-5 cursor-pointer" },
                [
                  _c("input", {
                    staticClass: "absolute inset-0 opacity-0 peer",
                    attrs: {
                      type: "checkbox",
                      name: _vm.name,
                      required: _vm.required,
                    },
                    domProps: { checked: _vm.checked, value: _vm.value },
                    on: { input: _vm.inputChange },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass:
                      "checkbox-border absolute inset-0 block border rounded-[3px] shadow-transparent duration-200",
                    class:
                      _vm.theme === "white"
                        ? "border-white peer-focus-visible:border-white/50"
                        : "border-blue peer-focus-visible:border-blue/50",
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "checkbox-checked absolute inset-0 flex items-center justify-center opacity-0 duration-200 peer-checked:opacity-100",
                      class:
                        _vm.theme === "white"
                          ? "bg-white text-blue"
                          : "bg-blue text-white",
                    },
                    [
                      _c("svg", { staticClass: "w-3 h-2 stroke-2" }, [
                        _c("use", { attrs: { "xlink:href": "#icon-check" } }),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.textInLabel
                ? _c(
                    "span",
                    { staticClass: "block select-none cursor-pointer text-sm" },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          !_vm.textInLabel ? _vm._t("default") : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.errorShow
        ? _c("p", { staticClass: "text-xs text-red" }, [
            _vm._v(_vm._s(_vm.errorText)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }